"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classifyPolygons = exports.ClassifyBehavior = void 0;
const turf_1 = require("@turf/turf");
const average_width_1 = require("../calculators/average-width");
const MIN_FOREST_AREA = (0, turf_1.convertArea)(1, 'hectares', 'meters');
const MIN_AVERAGE_WIDTH_METERS = 25;
var IneligibleReason;
(function (IneligibleReason) {
    IneligibleReason["Area"] = "Area";
    IneligibleReason["Width"] = "Width";
    IneligibleReason["CanopyCover"] = "CanopyCover";
})(IneligibleReason || (IneligibleReason = {}));
var ClassifyBehavior;
(function (ClassifyBehavior) {
    ClassifyBehavior["Post89"] = "Post89";
    ClassifyBehavior["Pre90"] = "Pre90";
    ClassifyBehavior["Legacy"] = "Legacy";
})(ClassifyBehavior = exports.ClassifyBehavior || (exports.ClassifyBehavior = {}));
/**
 * Converts a feature from an EtsInternal into a CommonGeoJsonProperties
 * by computing the ETS eligibility and categories.
 *
 * @param feature The feature to examine.
 * @param behavior
 * @returns A copy of the feature with ETS categories.
 */
function classifyFeature(feature, behavior) {
    const properties = {
        report_category: undefined,
        mature_canopy_cover_proportion: feature.properties.canopyCoverProportion,
    };
    const ineligibleReasons = [];
    // Check Area
    const featureArea = (0, turf_1.area)(feature);
    if (featureArea < MIN_FOREST_AREA) {
        ineligibleReasons.push(IneligibleReason.Area);
    }
    // Check Width
    const width = (0, average_width_1.approximatePolygonWidth)(feature);
    if (width && width < MIN_AVERAGE_WIDTH_METERS) {
        ineligibleReasons.push(IneligibleReason.Width);
    }
    if (behavior === ClassifyBehavior.Post89) {
        const report_category = feature.properties.ets_species === 'indigenous'
            ? 'existing_indigenous_ets_forest'
            : 'existing_exotic_ets_forest';
        properties.report_category =
            ineligibleReasons.length > 0 ? 'scattered_forest' : report_category;
    }
    if (behavior === ClassifyBehavior.Pre90) {
        properties.report_category = 'pre_1990_forest';
    }
    if (behavior === ClassifyBehavior.Legacy) {
        if (ineligibleReasons.length > 0) {
            properties.report_category = 'scattered_forest';
        }
        properties.ets_species = feature.properties.ets_species;
    }
    return {
        ...feature,
        properties: properties,
    };
}
/**
 * Classifies all of the features in a featureCollection.
 *
 * @param features The features to classify
 * @param behavior
 * @returns A new featureCollection of classified features
 */
function classifyPolygons(features, behavior) {
    return (0, turf_1.featureCollection)(features.features.map((feature) => classifyFeature(feature, behavior)));
}
exports.classifyPolygons = classifyPolygons;
